// @flow

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import {
  DisplayCardBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-card-brands';
import {creditCardOutgoingPaymentMapper} from '@tectonics/prs/credit-card';
import {
  CreditCardForm,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/credit-card-form';
import React from 'react';

export const CreditcardGuatemala: PaymentMethod = {
  code: 'creditcard',
  nameKey: 'volcanes.creditcard.name',
  placeOrderMessageKey: 'volcanes.creditcard.placeOrder',
  icons: <DisplayCardBrands />,
  outgoingPaymentMapper: creditCardOutgoingPaymentMapper,
  paymentMethodForm: <CreditCardForm />,
};
